<div class="dept-wise-layout"
     [class.mobile-show-content]="mobileShowContent"
     [class.operator-fullwidth]="showsCompactProjectView()">

<!-- Update toast notification -->
@if (updateToast()) {
<div class="fixed bottom-6 right-6 z-[9999] flex items-start gap-3 bg-white border border-emerald-300 shadow-xl rounded-2xl px-5 py-4 max-w-sm w-full animate-slide-in-right"
     role="alert" aria-live="polite">
    <div class="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
        <i class="fa-solid fa-circle-check text-emerald-600 text-sm"></i>
    </div>
    <div class="flex-1 min-w-0">
        <p class="text-sm font-bold text-slate-800">{{ updateToast()!.title }}</p>
        <ul class="mt-1.5 space-y-0.5">
            @for (line of updateToast()!.lines; track line) {
                <li class="text-xs text-slate-600 flex items-start gap-1.5">
                    <i class="fa-solid fa-arrow-right text-emerald-500 mt-0.5 flex-shrink-0 text-[10px]"></i>
                    {{ line }}
                </li>
            }
        </ul>
    </div>
    <button (click)="updateToast.set(null)" aria-label="Dismiss"
            class="flex-shrink-0 text-slate-400 hover:text-slate-600 transition mt-0.5">
        <i class="fa-solid fa-xmark text-sm"></i>
    </button>
</div>
}


  <!-- ===== LEFT PANEL: Department List (hidden for operators & approvers — they use the sidebar nav) ===== -->
  <aside class="dept-sidebar" *ngIf="!showsCompactProjectView()">
    <div class="dept-sidebar-header">
      <i class="fa-solid fa-building-columns"></i>
      <span>Departments</span>
      <span class="dept-count-pill">{{ departments.length }}</span>
    </div>
    <!-- Mobile subtitle under header -->
    <div class="mobile-dept-sub md:hidden">SELECT TO VIEW DETAILED SCHEMES</div>
    <ul class="dept-list">
      <li *ngFor="let dept of departments"
          (click)="selectDepartment(dept)"
          [class.active]="selectedDept?.name === dept.name"
          class="dept-list-item">
        <div class="dept-item-icon" [ngClass]="getDeptBg(dept.color)">
          <i [class]="dept.icon"></i>
        </div>
        <div class="dept-item-info">
          <span class="dept-item-name">{{ dept.name }}</span>
          <span class="dept-item-meta">
            @if (!showsCompactProjectView()) {
              {{ dept.schemes.length }} SCHEMES&nbsp;•&nbsp;{{ getDeptProjectCount(dept) }} PROJECTS
            } @else {
              {{ getDeptProjectCount(dept) }} PROJECTS
            }
          </span>
        </div>
        <i class="fa-solid fa-chevron-right dept-item-arrow"></i>
      </li>
    </ul>
  </aside>

  <!-- ===== RIGHT PANEL: Scheme Cards ===== -->
  <main class="dept-content" [class.min-dept-content]="isMinisterOrOsd() && deptViewMode() !== 'card'" *ngIf="selectedDept">

    <!-- Header -->
    <div class="scheme-panel-header" [class.min-scheme-header]="isMinisterOrOsd() && deptViewMode() !== 'card'">
      <div class="scheme-panel-title-row">
        <!-- Desktop Back Button (Chevron style matching snapshot) -->
        <button class="hidden md:flex items-center justify-center w-8 h-8 rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50 transition mr-2"
                (click)="goBackToDashboard()" aria-label="Back to dashboard">
          <i class="fa-solid fa-chevron-left text-xs"></i>
        </button>
        <!-- Mobile Back Button -->
        <button class="dept-mobile-back md:hidden" (click)="handleMobileBack()" aria-label="Go back">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <div class="scheme-dept-icon-lg" [ngClass]="getDeptBg(selectedDept.color)">
          <i [class]="selectedDept.icon"></i>
        </div>
        <div>
          <h2 class="scheme-panel-title">{{ selectedDept.name }}</h2>
          <!-- Subtitle hidden in the compact project-table view — header stays clean -->
          @if (!showsCompactProjectView() || (isMinisterOrOsd() && deptViewMode() === 'card')) {
            <p class="scheme-panel-subtitle text-xs text-slate-500">
              Department-wide scheme overview · Click a card to view projects
            </p>
          }
        </div>
      </div>

      <!-- Add Scheme: strict-admin only (Minister/OSD/Operator/Approver don't manage scheme structure) -->
      @if (isStrictAdmin()) {
        <div class="dept-admin-bar">
          <button class="btn-add-scheme" (click)="openAddSchemeModal()"
                  title="Add a new scheme to {{ selectedDept.name }}"
                  aria-label="Add scheme">
            <i class="fa-solid fa-plus"></i> Add Scheme
          </button>
        </div>
      }

      <!-- Summary strip -->
      @if (isMinisterOrOsd() && deptViewMode() !== 'card') {
        <!-- Premium stat cards — Minister / OSD table view -->
        <div class="min-stat-cards">
          <div class="min-stat-card blue">
            <div class="min-stat-icon"><i class="fa-solid fa-briefcase"></i></div>
            <div class="min-stat-body">
              <span class="min-stat-label"><span class="min-stat-label-full">Total Projects</span><span class="min-stat-label-short">Projects</span></span>
              <span class="min-stat-value">{{ totalProjects }}</span>
            </div>
          </div>
          <div class="min-stat-card emerald">
            <div class="min-stat-icon"><i class="fa-solid fa-indian-rupee-sign"></i></div>
            <div class="min-stat-body">
              <span class="min-stat-label"><span class="min-stat-label-full">Total Cost</span><span class="min-stat-label-short">Cost</span></span>
              <span class="min-stat-value">₹{{ totalCost.toFixed(2) }} L</span>
            </div>
          </div>
          <div class="min-stat-card violet">
            <div class="min-stat-icon"><i class="fa-solid fa-wallet"></i></div>
            <div class="min-stat-body">
              <span class="min-stat-label"><span class="min-stat-label-full">Budget Spent</span><span class="min-stat-label-short">Spent</span></span>
              <span class="min-stat-value">₹{{ totalSpent.toFixed(2) }} L</span>
            </div>
          </div>
        </div>
      } @else {
        <!-- Original grid — admin / operator / card view -->
        <div class="scheme-summary-grid grid grid-cols-2 md:grid-cols-4 gap-2 mb-3"
             [class.summary-compact]="showsCompactProjectView()">
          @if (!showsCompactProjectView() || (isMinisterOrOsd() && deptViewMode() === 'card')) {
            <div class="summary-card">
              <span class="label">Schemes</span>
              <span class="value">{{ totalSchemes }}</span>
            </div>
          }
          <div class="summary-card">
            <span class="label">Projects</span>
            <span class="value">{{ totalProjects }}</span>
          </div>
          <div class="summary-card">
            <span class="label">Total Cost</span>
            <span class="value">₹{{ totalCost.toFixed(2) }} L</span>
          </div>
          <div class="summary-card">
            <span class="label">Budget Spent</span>
            <span class="value">₹{{ totalSpent.toFixed(2) }} L</span>
          </div>
        </div>
      }

      <!-- Scheme search (shown for admin always; shown for minister/OSD in card view) -->
      @if (!showsCompactProjectView() || (isMinisterOrOsd() && deptViewMode() === 'card')) {
      <div class="scheme-search-wrap">
        <i class="fa-solid fa-magnifying-glass scheme-search-icon"></i>
        <input type="text" [(ngModel)]="searchQuery" placeholder="Search schemes…"
               class="scheme-search-input" id="scheme-search" />
        <span class="scheme-search-count" *ngIf="searchQuery">{{ filteredSchemes.length }} results</span>
      </div>
      }
    </div>

    <!-- ── OPERATOR / APPROVER / MINISTER / OSD: Compact project table ── -->
    @if (showsCompactProjectView()) {

      <!-- ══ MOBILE APP SHELL (card-first, ≤767px) ══ -->
      <div class="dept-mob-app dept-mobile-only">
        <div class="dept-mob-head">
          <button type="button" class="dept-mob-back" (click)="handleMobileBack()" aria-label="Go back">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <div class="dept-mob-head-icon" [ngClass]="getDeptBg(selectedDept!.color)">
            <i [class]="selectedDept!.icon"></i>
          </div>
          <h1 class="dept-mob-head-title">{{ selectedDept!.name }}</h1>
          <span class="dept-mob-head-badge">{{ opFilteredProjects.length }}</span>
          <button type="button"
                  class="dept-mob-export-icon"
                  (click)="exportDeptProjectsXlsx()"
                  title="Export to Excel"
                  aria-label="Export filtered projects to Excel">
            <i class="fa-solid fa-file-excel"></i>
          </button>
        </div>

        <div class="dept-mob-controls">
          <div class="dept-mob-search">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            <input type="search" [(ngModel)]="opTableSearch" placeholder="Search…" aria-label="Search projects" />
          </div>
          <button type="button" class="dept-mob-filters-btn" (click)="openMobileFilterSheet()" aria-label="More filters">
            <i class="fa-solid fa-sliders"></i>
            @if (mobileSheetFilterCount() > 0) {
              <span class="dept-mob-filter-count">{{ mobileSheetFilterCount() }}</span>
            }
          </button>
        </div>

        <div class="dept-mob-filter-scroll" aria-label="Quick filters">
          <select [(ngModel)]="opTableStatus" class="dept-mob-select dept-mob-select--chip" aria-label="Filter by status">
            <option value="">Status</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Stuck">Stuck</option>
          </select>
          @if (isMinisterOrOsd()) {
            <select [ngModel]="opTableBlock"
                    (ngModelChange)="opTableBlock = $event; opTableGp = ''"
                    class="dept-mob-select dept-mob-select--chip" aria-label="Filter by block">
              <option value="">Block</option>
              @for (b of opAvailableBlocks; track b) {
                <option [value]="b">{{ b }}</option>
              }
            </select>
            <button type="button" class="dept-mob-select dept-mob-filter-trigger dept-mob-select--chip"
                    (click)="openMobileFilterSheet()" aria-label="Filter by scheme">
              {{ opSelectedSchemes().size ? (opSelectedSchemes().size + ' Schemes') : 'Scheme' }}
            </button>
            <select [(ngModel)]="opTableGp" class="dept-mob-select dept-mob-select--chip" aria-label="Filter by GP">
              <option value="">GP</option>
              @for (g of opAvailableGps; track g) {
                <option [value]="g">{{ g }}</option>
              }
            </select>
          } @else {
            <select [(ngModel)]="opTableScheme" class="dept-mob-select dept-mob-select--chip" aria-label="Filter by scheme">
              <option value="">Scheme</option>
              @for (s of opAvailableSchemes; track s.short) {
                <option [value]="s.short">{{ s.short }}</option>
              }
            </select>
            <select [(ngModel)]="opTableProgressBand" class="dept-mob-select dept-mob-select--chip" aria-label="Filter by progress">
              <option value="">Progress</option>
              <option value="<30">&lt; 30%</option>
              <option value="30-70">30–70%</option>
              <option value=">=70">≥ 70%</option>
            </select>
          }
        </div>

        <div class="dept-mob-seg" role="tablist" aria-label="Project view mode">
          <button type="button" role="tab"
                  [class.active]="mobileProjView() === 'list'"
                  [attr.aria-selected]="mobileProjView() === 'list'"
                  (click)="mobileProjView.set('list')">
            <i class="fa-solid fa-list"></i> List
          </button>
          <button type="button" role="tab"
                  [class.active]="mobileProjView() === 'cards'"
                  [attr.aria-selected]="mobileProjView() === 'cards'"
                  (click)="mobileProjView.set('cards')">
            <i class="fa-solid fa-grip"></i> Cards
          </button>
        </div>

        @if (opFilteredProjects.length === 0) {
          <div class="dept-mob-empty">
            <div class="dept-mob-empty-icon"><i class="fa-regular fa-folder-open"></i></div>
            <h3>No Projects Available</h3>
            <p>Adjust filters or check back later for new projects in this department.</p>
            @if (hasActiveMobileFilters()) {
              <button type="button" class="dept-mob-empty-btn" (click)="opResetFilters()">Clear filters</button>
            }
          </div>
        } @else if (mobileProjView() === 'cards') {
          <div class="dept-mob-proj-cards">
            @for (p of opPagedProjects; track p.id ?? (p.schemeName + '-' + p.slNo)) {
              <article class="dept-mob-proj-card" (click)="openDeptProjectModal(p)">
                <div class="dept-mob-proj-card-top">
                  <div class="dept-mob-proj-card-title">
                    <i class="fa-solid fa-diagram-project" aria-hidden="true"></i>
                    <span>{{ p.roadName }}</span>
                  </div>
                  <i class="fa-solid fa-chevron-right dept-mob-proj-chevron" aria-hidden="true"></i>
                </div>
                <p class="dept-mob-proj-dept">{{ selectedDept!.name }} Department</p>
                <div class="dept-mob-proj-meta">
                  <span><i class="fa-solid fa-map-pin"></i> {{ mobileLocationOf(p) }}</span>
                  <span><i class="fa-solid fa-indian-rupee-sign"></i> ₹{{ p.costLakh | number:'1.0-2' }} L</span>
                </div>
                <div class="dept-mob-proj-foot">
                  <span [class]="opStatusClass(p.status)">{{ mobileStatusLabel(p.status) }}</span>
                  <span class="dept-mob-proj-scheme">{{ p.schemeShort || p.schemeName }}</span>
                </div>
                <p class="dept-mob-proj-updated">{{ mobileUpdatedLabel(p) }}</p>
              </article>
            }
          </div>
        } @else {
          <div class="dept-mob-proj-list">
            @for (p of opPagedProjects; track p.id ?? (p.schemeName + '-' + p.slNo)) {
              <button type="button" class="dept-mob-proj-row" (click)="openDeptProjectModal(p)">
                <div class="dept-mob-proj-row-main">
                  <span class="dept-mob-proj-row-name">{{ p.roadName }}</span>
                  <span class="dept-mob-proj-row-cost">₹{{ p.costLakh | number:'1.0-2' }} L</span>
                </div>
                <div class="dept-mob-proj-row-sub">
                  <span [class]="opStatusClass(p.status)">{{ mobileStatusLabel(p.status) }}</span>
                  <span>{{ p.schemeShort || p.schemeName }}</span>
                  <span>{{ mobileLocationOf(p) }}</span>
                </div>
              </button>
            }
          </div>
        }

        @if (opFilteredProjects.length > 0) {
          <div class="dept-mob-pagination">
            <span>{{ opPageRange }}</span>
            <div class="dept-mob-page-btns">
              <button type="button" (click)="opPrevPage()" [disabled]="opPage() === 1" aria-label="Previous page">
                <i class="fa-solid fa-chevron-left"></i>
              </button>
              <span>{{ opPage() }} / {{ opTotalPages }}</span>
              <button type="button" (click)="opNextPage()" [disabled]="opPage() === opTotalPages" aria-label="Next page">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        }
      </div>

      @if (mobileFilterSheetOpen()) {
        <div class="dept-mob-sheet-overlay" (click)="closeMobileFilterSheet()" role="presentation">
          <div class="dept-mob-sheet" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-label="Advanced filters">
            <div class="dept-mob-sheet-handle"></div>
            <div class="dept-mob-sheet-header">
              <h3 class="dept-mob-sheet-title">Filters</h3>
              <button type="button" class="dept-mob-sheet-close" (click)="closeMobileFilterSheet()" aria-label="Close filters">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="dept-mob-sheet-body">
              @if (isMinisterOrOsd()) {
                <label class="dept-mob-sheet-label">Scheme</label>
                <div class="dept-mob-sheet-schemes">
                  <div class="dept-mob-sheet-scheme-actions">
                    <button type="button" (click)="selectAllSchemes()">Select all</button>
                    <button type="button" (click)="clearSchemeSelection()" [disabled]="opSelectedSchemes().size === 0">Clear</button>
                  </div>
                  <ul>
                    @for (s of opAvailableSchemes; track s.short) {
                      <li>
                        <label>
                          <input type="checkbox"
                                 [checked]="isSchemeSelected(s.short)"
                                 (change)="toggleSchemeInSelection(s.short)" />
                          <span>{{ s.short }}</span>
                        </label>
                      </li>
                    }
                  </ul>
                </div>
                <label class="dept-mob-sheet-label">Executant</label>
                <div class="dept-mob-exec-list" role="listbox" aria-label="Filter by executant">
                  <button type="button"
                          class="dept-mob-exec-opt"
                          [class.active]="!opTableExecutant"
                          (click)="setMobileExecutant('')"
                          role="option"
                          [attr.aria-selected]="!opTableExecutant">
                    All Executants
                  </button>
                  @for (e of opAvailableExecutants; track e) {
                    <button type="button"
                            class="dept-mob-exec-opt"
                            [class.active]="opTableExecutant === e"
                            (click)="setMobileExecutant(e)"
                            role="option"
                            [attr.aria-selected]="opTableExecutant === e">
                      {{ e }}
                    </button>
                  }
                  @if (opAvailableExecutants.length === 0) {
                    <p class="dept-mob-exec-empty">No executants in this department</p>
                  }
                </div>
              } @else {
                <label class="dept-mob-sheet-label" for="mob-sort">Sort by</label>
                <select id="mob-sort" [(ngModel)]="opTableSort" class="dept-mob-select dept-mob-sheet-select">
                  <option value="updated-desc">Updated · Newest</option>
                  <option value="updated-asc">Updated · Oldest</option>
                  <option value="cost-desc">Cost · High → Low</option>
                  <option value="cost-asc">Cost · Low → High</option>
                  <option value="name">Project Name</option>
                </select>
              }
            </div>
            <div class="dept-mob-sheet-actions">
              <button type="button" class="dept-mob-sheet-clear" (click)="opResetFilters()">Reset</button>
              <button type="button" class="dept-mob-sheet-apply" (click)="applyMobileFilters()">Apply</button>
            </div>
          </div>
        </div>
      }

      <div class="dept-desktop-only">
      <!-- ── VIEW TOGGLE (minister/OSD only) ── -->
      @if (isMinisterOrOsd()) {
        <div class="vt-bar min-vt-bar">
          <div class="vt-group">
            <button class="vt-btn" [class.vt-btn-active]="deptViewMode() === 'table'"
                    (click)="deptViewMode.set('table')"
                    title="Switch to table view">
              <i class="fa-solid fa-table-list"></i>
              <span class="vt-label">Table View</span>
            </button>
            <button class="vt-btn" [class.vt-btn-active]="deptViewMode() === 'card'"
                    (click)="deptViewMode.set('card')"
                    title="Switch to card view">
              <i class="fa-solid fa-grip"></i>
              <span class="vt-label">Card View</span>
            </button>
          </div>
          <span class="vt-hint">
            @if (deptViewMode() === 'table') { Showing all projects in a list }
            @else { Showing scheme-wise cards · Click a card to view projects }
          </span>
        </div>
      }

      @if (!isMinisterOrOsd() || deptViewMode() === 'table') {
      <!-- Toolbar -->
      <div class="op-table-toolbar" [class.min-toolbar]="isMinisterOrOsd()">
        <div class="op-search-wrap">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="text" [(ngModel)]="opTableSearch"
                 [placeholder]="isMinisterOrOsd() ? 'Search name, scheme, GP, ID…' : 'Search name, scheme, district, block, ID…'" />
        </div>
        <select [(ngModel)]="opTableStatus" class="op-select" aria-label="Filter by status">
          <option value="">All Status</option>
          <option value="Planned">Planned</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
          <option value="Stuck">Stuck</option>
        </select>
        @if (isMinisterOrOsd()) {
          <!-- OSD/Minister: multi-select checkbox dropdown — view projects under multiple schemes at once -->
          <div class="op-multi-schemes" [class.is-open]="isOpSchemesMenuOpen()">
            <button type="button" class="op-multi-trigger"
                    (click)="toggleOpSchemesMenu()"
                    [class.has-selection]="opSelectedSchemes().size > 0"
                    aria-haspopup="true"
                    [attr.aria-expanded]="isOpSchemesMenuOpen()">
              <span class="op-multi-label">{{ opSelectedSchemesLabel }}</span>
              @if (opSelectedSchemes().size > 0) {
                <span class="op-multi-count">{{ opSelectedSchemes().size }}</span>
              }
              <i class="fa-solid fa-caret-down"></i>
            </button>
            @if (isOpSchemesMenuOpen()) {
              <div class="op-multi-panel" (click)="$event.stopPropagation()">
                <div class="op-multi-toolbar">
                  <button type="button" class="op-multi-link" (click)="selectAllSchemes()">Select all</button>
                  <button type="button" class="op-multi-link"
                          (click)="clearSchemeSelection()"
                          [disabled]="opSelectedSchemes().size === 0">Clear</button>
                </div>
                <ul class="op-multi-list">
                  @for (s of opAvailableSchemes; track s.short) {
                    <li>
                      <label class="op-multi-item" [title]="s.full">
                        <input type="checkbox"
                               [checked]="isSchemeSelected(s.short)"
                               (change)="toggleSchemeInSelection(s.short)" />
                        <span class="op-multi-short">{{ s.short }}</span>
                        <span class="op-multi-full">{{ s.full }}</span>
                      </label>
                    </li>
                  }
                  @if (opAvailableSchemes.length === 0) {
                    <li class="op-multi-empty">No schemes available for this department.</li>
                  }
                </ul>
                <div class="op-multi-footer">
                  <button type="button" class="op-multi-apply" (click)="closeOpSchemesMenu()">Done</button>
                </div>
              </div>
            }
          </div>
        } @else {
          <!-- Operator / Approver / Admin: original single-select -->
          <select [(ngModel)]="opTableScheme" class="op-select" aria-label="Filter by scheme">
            <option value="">All Schemes</option>
            @for (s of opAvailableSchemes; track s.short) {
              <option [value]="s.short" [title]="s.full">{{ s.short }}</option>
            }
          </select>
        }

        <!-- OSD/Minister extra filters: Block → GP (dependent) → Executant -->
        @if (isMinisterOrOsd()) {
          <select [ngModel]="opTableBlock"
                  (ngModelChange)="opTableBlock = $event; opTableGp = ''"
                  class="op-select" aria-label="Filter by block">
            <option value="">All Blocks</option>
            @for (b of opAvailableBlocks; track b) {
              <option [value]="b">{{ b }}</option>
            }
          </select>
          <select [(ngModel)]="opTableGp" class="op-select" aria-label="Filter by GP">
            <option value="">All GP</option>
            @for (g of opAvailableGps; track g) {
              <option [value]="g">{{ g }}</option>
            }
          </select>
          <select [(ngModel)]="opTableExecutant" class="op-select" aria-label="Filter by executant">
            <option value="">All Executants</option>
            @for (e of opAvailableExecutants; track e) {
              <option [value]="e">{{ e }}</option>
            }
          </select>
        }

        <!-- Progress band & sort: operator/approver only -->
        @if (!isMinisterOrOsd()) {
          <select [(ngModel)]="opTableProgressBand" class="op-select" aria-label="Filter by progress">
            <option value="">All Progress</option>
            <option value="<30">&lt; 30%</option>
            <option value="30-70">30% – 70%</option>
            <option value=">=70">≥ 70%</option>
          </select>
          <select [(ngModel)]="opTableSort" class="op-select" aria-label="Sort">
            <option value="updated-desc">Updated · Newest</option>
            <option value="updated-asc">Updated · Oldest</option>
            <option value="cost-desc">Cost · High → Low</option>
            <option value="cost-asc">Cost · Low → High</option>
            <option value="name">Project Name</option>
          </select>
        }

        <button class="op-btn-secondary" (click)="opResetFilters()" title="Clear all filters">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <button class="op-btn-export"
                (click)="exportDeptProjectsXlsx()"
                title="Export the filtered project list to Excel">
          <i class="fa-solid fa-file-excel"></i>
          <span>Export</span>
        </button>
        <span class="op-row-count">{{ opFilteredProjects.length }} of {{ opAllProjects.length }} projects</span>
      </div>

      <!-- Project table -->
      <div class="op-table-wrap" [class.min-table-wrap]="isMinisterOrOsd()">
        <table class="op-projects-table" [class.min-table]="isMinisterOrOsd()">
          <thead>
            <tr>
              <th class="op-sl">#</th>
              <th class="op-name">Project Name</th>
              <th class="op-scheme">Scheme</th>
              @if (isMinisterOrOsd()) {
                <th>GP Name</th>
              } @else {
                <th>District</th>
                <th>Block / Division</th>
              }
              <th class="op-num">Length (km)</th>
              <th class="op-num">Approx Cost (₹L)</th>
              <th>Status</th>
              @if (!isMinisterOrOsd()) { <th class="op-prog">Progress</th> }
              <th>Last Updated</th>
              @if (isApprover()) { <th>Approval Status</th> }
              @if (isOperator() || isApprover()) { <th class="op-actions">Actions</th> }
            </tr>
          </thead>
          <tbody>
            @for (p of opPagedProjects; track p.id ?? (p.schemeName + '-' + p.slNo); let i = $index) {
              <tr>
                <td class="op-sl">{{ opSlForIndex(i) }}</td>
                <td class="op-name">
                  <button type="button"
                          class="op-project-link"
                          (click)="openDeptProjectModal(p)"
                          [title]="'View project details'">
                    {{ p.roadName }}
                  </button>
                </td>
                <td class="op-scheme">
                  <span class="op-scheme-chip" [title]="p.schemeName">{{ p.schemeShort }}</span>
                </td>
                @if (isMinisterOrOsd()) {
                  <td>{{ $any(p).gp || '—' }}</td>
                } @else {
                  <td>{{ p.district || '—' }}</td>
                  <td>{{ p.division || '—' }}</td>
                }
                <td class="op-num">{{ p.lengthKm !== undefined ? (p.lengthKm | number:'1.1-2') : '—' }}</td>
                <td class="op-num">{{ p.costLakh | number:'1.0-2' }}</td>
                <td>
                  <span [class]="opStatusClass(p.status)">{{ p.status || 'Planned' }}</span>
                </td>
                @if (!isMinisterOrOsd()) {
                  <td class="op-prog">
                    <div class="op-progress-bar"><div class="op-progress-fill" [style.width.%]="opProgressOf(p)"></div></div>
                    <span class="op-progress-val">{{ opProgressOf(p) }}%</span>
                  </td>
                }
                <td>{{ lastUpdatedOf(p) }}</td>
                @if (isApprover()) {
                  <td>
                    <span [class]="approvalStatusOf(p).cls">{{ approvalStatusOf(p).label }}</span>
                  </td>
                }
                @if (isOperator() || isApprover()) {
                  <td class="op-actions">
                    @if (isOperator()) {
                      <button class="op-act op-act-edit"   (click)="opEditProject(p)"  title="Edit project — changes go to approval"><i class="fa-solid fa-pen-to-square"></i></button>
                      <button class="op-act op-act-delete" (click)="promptOpDelete(p)" title="Delete project — sends to approval"><i class="fa-solid fa-trash-can"></i></button>
                    }
                    @if (isApprover()) {
                      <button class="op-act op-act-edit" (click)="approverViewProject(p)" title="View project / pending request"><i class="fa-solid fa-eye"></i></button>
                    }
                  </td>
                }
              </tr>
            }
            @if (opFilteredProjects.length === 0) {
              <tr>
                <td [attr.colspan]="opProjectsColspan()" class="op-empty">
                  <i class="fa-regular fa-folder-open"></i>
                  <p>No projects match the current filters.</p>
                  @if (opTableSearch || opTableStatus || opTableScheme || opTableProgressBand) {
                    <button class="op-btn-secondary" (click)="opResetFilters()">Clear filters</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination footer -->
      @if (opFilteredProjects.length > 0) {
        <div class="op-pagination" [class.min-pagination]="isMinisterOrOsd()">
          <div class="op-pagination-left">
            <span class="op-pagination-range">{{ opPageRange }}</span>
            <label class="op-page-size">
              <span>Rows:</span>
              <select [ngModel]="opPageSize()" (ngModelChange)="opSetPageSize($event)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
            </label>
          </div>
          <div class="op-pagination-right">
            <button class="op-page-btn" (click)="opGoToPage(1)" [disabled]="opPage() === 1"
                    title="First page">
              <i class="fa-solid fa-angles-left"></i>
            </button>
            <button class="op-page-btn" (click)="opPrevPage()" [disabled]="opPage() === 1"
                    title="Previous page">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <span class="op-page-indicator">Page {{ opPage() }} / {{ opTotalPages }}</span>
            <button class="op-page-btn" (click)="opNextPage()" [disabled]="opPage() === opTotalPages"
                    title="Next page">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
            <button class="op-page-btn" (click)="opGoToPage(opTotalPages)" [disabled]="opPage() === opTotalPages"
                    title="Last page">
              <i class="fa-solid fa-angles-right"></i>
            </button>
          </div>
        </div>
      }
      } <!-- end table view -->

      <!-- ── CARD VIEW: minister/OSD only ── -->
      @if (isMinisterOrOsd() && deptViewMode() === 'card') {
        <div class="scheme-cards-grid">
          <div *ngFor="let scheme of filteredSchemes; let i = index"
               class="scheme-card"
               [ngClass]="getDeptBg(selectedDept!.color)"
               [class.has-projects]="scheme.projects > 0"
               (click)="openSchemeDrawer(scheme)"
               [attr.id]="'scheme-card-v-' + i">

            <!-- Card header (no edit/delete for minister/OSD) -->
            <div class="scheme-card-header">
              <span class="scheme-serial">{{ i + 1 }}</span>
              <h3 class="scheme-card-title">{{ scheme.name }}</h3>
              <i class="fa-solid fa-arrow-up-right-from-square scheme-card-link-icon"
                 *ngIf="scheme.projects > 0" title="View project list"></i>
            </div>

            <!-- Stats rows -->
            <div class="scheme-stats">
              <div class="scheme-stat-row">
                <span class="stat-label">Projects:</span>
                <span class="stat-value">{{ scheme.projects }}</span>
              </div>
              <div class="scheme-stat-row" *ngIf="scheme.roadLength !== undefined">
                <span class="stat-label">Road Length:</span>
                <span class="stat-value bold">{{ scheme.roadLength!.toFixed(2) }} km</span>
              </div>
              <div class="scheme-stat-row">
                <span class="stat-label">Total Cost:</span>
                <span class="stat-value bold">₹{{ scheme.totalCost.toFixed(2) }} L</span>
              </div>
              <div class="scheme-stat-row">
                <span class="stat-label">Spent:</span>
                <span class="stat-value bold">₹{{ scheme.spent.toFixed(2) }} L</span>
              </div>
            </div>

            <!-- Status pills -->
            <div class="scheme-status-pills">
              <span class="pill pill-completed"  title="Completed">{{ scheme.completed }} C</span>
              <span class="pill pill-inprogress" title="In Progress">{{ scheme.inProgress }} IP</span>
              <span class="pill pill-stuck"      title="Stuck">{{ scheme.stuck }} S</span>
              <span class="pill pill-planned"    title="Planned">{{ scheme.planned }} P</span>
            </div>

            <!-- View projects hint -->
            <div class="scheme-card-hint" *ngIf="scheme.projects > 0">
              <i class="fa-solid fa-table-list"></i> View {{ scheme.projects }} project{{ scheme.projects > 1 ? 's' : '' }}
            </div>
          </div>

          <!-- Empty state -->
          <div class="scheme-empty" *ngIf="filteredSchemes.length === 0">
            <i class="fa-solid fa-magnifying-glass text-3xl mb-3 opacity-30"></i>
            <p>No schemes match "<strong>{{ searchQuery }}</strong>"</p>
          </div>
        </div>
      }
      </div><!-- /dept-desktop-only -->
    }

    <!-- ── ADMIN: Original scheme cards (Minister/OSD now use the compact table) ── -->
    @if (!showsCompactProjectView()) {
    <div class="scheme-cards-grid">
      <div *ngFor="let scheme of filteredSchemes; let i = index"
           class="scheme-card"
           [ngClass]="getDeptBg(selectedDept.color)"
           [class.has-projects]="scheme.projects > 0"
           (click)="openSchemeDrawer(scheme)"
           [attr.id]="'scheme-card-' + i">

        <!-- Card header -->
        <div class="scheme-card-header">
          <span class="scheme-serial">{{ i + 1 }}</span>
          <h3 class="scheme-card-title">{{ scheme.name }}</h3>
          <div class="scheme-card-actions" (click)="$event.stopPropagation()">
            <button class="scheme-card-edit-btn"
                    (click)="openEditSchemeModal(scheme, i, $event)"
                    [attr.aria-label]="'Edit ' + scheme.name"
                    title="Edit scheme">
              <i class="fa-solid fa-pen-to-square"></i>
            </button>
            <button class="scheme-card-delete-btn"
                    (click)="promptDeleteScheme(i, $event)"
                    [attr.aria-label]="'Delete ' + scheme.name"
                    title="Delete scheme">
              <i class="fa-solid fa-trash-can"></i>
            </button>
          </div>
          <i class="fa-solid fa-arrow-up-right-from-square scheme-card-link-icon"
             *ngIf="scheme.projects > 0" title="View project list"></i>
        </div>

        <!-- Stats rows -->
        <div class="scheme-stats">
          <div class="scheme-stat-row">
            <span class="stat-label">Projects:</span>
            <span class="stat-value">{{ scheme.projects }}</span>
          </div>
          <div class="scheme-stat-row" *ngIf="scheme.roadLength !== undefined">
            <span class="stat-label">Road Length:</span>
            <span class="stat-value bold">{{ scheme.roadLength!.toFixed(2) }} km</span>
          </div>
          <div class="scheme-stat-row">
            <span class="stat-label">Total Cost:</span>
            <span class="stat-value bold">₹{{ scheme.totalCost.toFixed(2) }} L</span>
          </div>
          <div class="scheme-stat-row">
            <span class="stat-label">Spent:</span>
            <span class="stat-value bold">₹{{ scheme.spent.toFixed(2) }} L</span>
          </div>
        </div>

        <!-- Status pills -->
        <div class="scheme-status-pills">
          <span class="pill pill-completed"  title="Completed">{{ scheme.completed }} C</span>
          <span class="pill pill-inprogress" title="In Progress">{{ scheme.inProgress }} IP</span>
          <span class="pill pill-stuck"      title="Stuck">{{ scheme.stuck }} S</span>
          <span class="pill pill-planned"    title="Planned">{{ scheme.planned }} P</span>
        </div>

        <!-- "View projects" hint shown only on hover when list exists -->
        <div class="scheme-card-hint" *ngIf="scheme.projects > 0">
          <i class="fa-solid fa-table-list"></i> View {{ scheme.projects }} project{{ scheme.projects > 1 ? 's' : '' }}
        </div>

        <!-- Add Project: hidden for OSD/Minister (read-only oversight) -->
        @if (!isMinisterOrOsd()) {
          <button class="scheme-card-add-btn"
                  (click)="openSchemeDrawerWithAdd(scheme, $event)"
                  title="Add a project to this scheme"
                  aria-label="Add project to {{ scheme.name }}">
            <i class="fa-solid fa-plus"></i> Add Project
          </button>
        }
      </div>

      <!-- Empty state -->
      <div class="scheme-empty" *ngIf="filteredSchemes.length === 0">
        <i class="fa-solid fa-magnifying-glass text-3xl mb-3 opacity-30"></i>
        <p>No schemes match "<strong>{{ searchQuery }}</strong>"</p>
      </div>
    </div>
    }
  </main>
</div>

<!-- ================================================================
     APPROVER PROJECT-VIEW MODAL
     Read-only when there's no open request; approve / reject when there is.
     ================================================================ -->
<app-compare-changes
  [isOpen]="approverModalOpen()"
  [beforeData]="approverModalBefore()"
  [newData]="approverModalAfter()"
  [meta]="approverModalMeta()"
  [readOnly]="approverModalReadOnly()"
  [isSubmitting]="approverSubmitting()"
  (close)="closeApproverModal()"
  (approve)="approverApprove($any($event))"
  (reject)="approverReject($any($event))"
></app-compare-changes>

<!-- ================================================================
     OPERATOR DELETE CONFIRMATION
     Submits a delete request to the department approver — never deletes live.
     ================================================================ -->
@if (opDeleteTarget()) {
  <div class="op-confirm-overlay" (click)="cancelOpDelete()">
    <div class="op-confirm-card" (click)="$event.stopPropagation()">
      @if (!opDeleteSubmitted()) {
        <div class="op-confirm-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <h3 class="op-confirm-title">Are you sure you want to delete this project?</h3>
        <p class="op-confirm-sub">
          The deletion will be reviewed by your department approver. The live project record
          will remain unchanged until the request is approved.
        </p>
        <div class="op-confirm-target">
          <span class="lbl">Project</span>
          <span class="val">{{ opDeleteTarget()?.roadName }}</span>
        </div>
        <div class="op-confirm-meta">
          <div><span class="lbl">Scheme</span><span class="val">{{ opDeleteTarget()?.schemeName }}</span></div>
          <div><span class="lbl">District</span><span class="val">{{ opDeleteTarget()?.district || '—' }}</span></div>
          <div><span class="lbl">Block / Division</span><span class="val">{{ opDeleteTarget()?.division || '—' }}</span></div>
        </div>
        @if (opDeleteError()) {
          <div class="op-confirm-error">
            <i class="fa-solid fa-circle-exclamation"></i> {{ opDeleteError() }}
          </div>
        }
        <div class="op-confirm-actions">
          <button class="op-btn-cancel" (click)="cancelOpDelete()" [disabled]="opIsSubmittingDelete()">Cancel</button>
          <button class="op-btn-submit" (click)="confirmOpDelete()" [disabled]="opIsSubmittingDelete()">
            @if (opIsSubmittingDelete()) {
              <i class="fa-solid fa-spinner fa-spin"></i> Sending…
            } @else {
              <i class="fa-solid fa-paper-plane"></i> Send For Approval
            }
          </button>
        </div>
      } @else {
        <div class="op-confirm-success-icon">
          <i class="fa-solid fa-circle-check"></i>
        </div>
        <h3 class="op-confirm-title">Delete request sent for approval</h3>
        <p class="op-confirm-sub">
          Your department approver has been notified. You can track the status under
          <strong>My Recent Requests</strong> on the Operator Console.
        </p>
      }
    </div>
  </div>
}

<!-- ================================================================
     SLIDE-OVER DRAWER: Project List
     ================================================================ -->

<!-- Backdrop -->
<div class="drawer-backdrop"
     [class.open]="drawerOpen"
     (click)="closeDrawer()">
</div>

<!-- Drawer panel -->
<div class="drawer-panel"
     [class.open]="drawerOpen"
     *ngIf="drawerScheme">

  <!-- Drawer header -->
  <div class="drawer-header" [ngClass]="drawerDept ? getDeptBg(drawerDept.color) : ''">
    <div class="drawer-header-inner">
      <div>
        <p class="drawer-dept-label">{{ drawerDept!.name }}</p>
        <h2 class="drawer-scheme-title">{{ drawerScheme!.name }}</h2>
        <p class="drawer-year-label">
          <i class="fa-solid fa-calendar-days mr-1"></i>
          Dhamnagar Assembly Constituency · 2025-26
        </p>
      </div>
      <button class="drawer-close-btn" (click)="closeDrawer()" id="drawer-close-btn">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Summary pills inside header -->
    <div class="drawer-header-pills">
      <div class="drawer-pill">
        <i class="fa-solid fa-list-ol"></i>
        <span>{{ drawerScheme!.projects }} Projects</span>
      </div>
      <div class="drawer-pill" *ngIf="drawerScheme!.roadLength! > 0">
        <i class="fa-solid fa-ruler-horizontal"></i>
        <span>{{ drawerScheme!.roadLength!.toFixed(2) }} km Total</span>
      </div>
      <div class="drawer-pill">
        <i class="fa-solid fa-indian-rupee-sign"></i>
        <span>₹{{ drawerTotalCostLakh.toFixed(2) }} L Approx. Cost</span>
      </div>
    </div>
  </div>

  <!-- Bulk deletion confirmation modal -->
  @if (showBulkDeleteConfirm()) {
  <div class="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4"
       role="alertdialog" aria-modal="true" aria-labelledby="bulk-del-title">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
      <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
        <i class="fa-solid fa-trash-can text-red-600 text-lg"></i>
      </div>
      <h3 id="bulk-del-title" class="text-base font-bold text-slate-900 mb-1">Delete {{ selectedSlNos().size }} project{{ selectedSlNos().size > 1 ? 's' : '' }}?</h3>
      <p class="text-sm text-slate-500 mb-5">This will permanently remove the selected projects from Firestore. This cannot be undone.</p>
      <div class="flex gap-3">
        <button type="button" (click)="clearSelection()"
                class="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition">Cancel</button>
        <button type="button" (click)="bulkDeleteProjects()" [disabled]="isBulkDeleting()"
                class="flex-1 px-3 py-2 bg-red-600 text-white rounded-lg text-sm font-semibold hover:bg-red-700 transition disabled:opacity-60 flex items-center justify-center gap-1.5">
          @if (isBulkDeleting()) {
            <i class="fa-solid fa-spinner animate-spin"></i> Deleting…
          } @else {
            <i class="fa-solid fa-trash-can"></i> Delete All
          }
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Drawer toolbar — hidden in operator focus-edit mode -->
  @if (!opFocusEditMode()) {
    <div class="drawer-toolbar">
      @if (!showAddForm) {
        <button class="btn-add-project" (click)="openAddProjectForm()">
          <i class="fa-solid fa-plus"></i> Add Project
        </button>
      }
    </div>
  }

  <!-- Bulk action bar -->
  @if (selectedSlNos().size > 0 && !showAddForm) {
  <div class="flex items-center justify-between gap-3 px-5 py-3 bg-red-50 border-b border-red-200">
    <span class="flex items-center gap-2 text-red-700 text-sm font-semibold">
      <i class="fa-solid fa-circle-check text-red-500"></i>
      {{ selectedSlNos().size }} project{{ selectedSlNos().size > 1 ? 's' : '' }} selected
    </span>
    <div class="flex items-center gap-2">
      <button type="button" (click)="clearSelection()"
              class="text-sm px-3 py-1.5 rounded-lg border border-slate-300 bg-white text-slate-600 hover:bg-slate-50 transition">
        <i class="fa-solid fa-xmark mr-1"></i> Cancel
      </button>
      <button type="button" (click)="showBulkDeleteConfirm.set(true)"
              class="text-sm px-3 py-1.5 rounded-lg bg-red-600 text-white hover:bg-red-700 transition flex items-center gap-1.5">
        <i class="fa-solid fa-trash-can"></i> Delete Selected
      </button>
    </div>
  </div>
  }

  <!-- ═══════════════════════════════════════════════════════════════
       ADD / EDIT PROJECT — Premium Enterprise Modal
       ═══════════════════════════════════════════════════════════════ -->
  @if (showAddForm) {
    <div class="ap-overlay" (click)="closeAddProjectForm()">
      <div class="ap-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">

        <!-- ── Header ── -->
        <div class="ap-header">
          <div class="ap-header-left">
            <div class="ap-header-icon" [class.ap-header-icon--edit]="formMode === 'edit'">
              <i class="fa-solid" [class.fa-file-circle-plus]="formMode === 'add'" [class.fa-pen-to-square]="formMode === 'edit'"></i>
            </div>
            <div class="ap-header-meta">
              <h2 class="ap-header-title">
                {{ addProjectForm.get('roadName')?.value?.trim() || (formMode === 'edit' ? 'Edit Project' : 'New Project') }}
              </h2>
              <div class="ap-header-chips">
                @if (drawerScheme.name) {
                  <span class="ap-chip ap-chip--blue"><i class="fa-solid fa-diagram-project"></i>{{ drawerScheme!.name }}</span>
                }
                @if (drawerDept?.shortName || drawerDept?.name) {
                  <span class="ap-chip ap-chip--purple"><i class="fa-solid fa-building-columns"></i>{{ drawerDept!.shortName || drawerDept!.name }}</span>
                }
                @if (addProjectForm.get('division')?.value) {
                  <span class="ap-chip ap-chip--teal"><i class="fa-solid fa-map-pin"></i>{{ addProjectForm.get('division')?.value }}</span>
                }
                @if (addProjectForm.get('gp')?.value) {
                  <span class="ap-chip ap-chip--green"><i class="fa-solid fa-tree-city"></i>{{ addProjectForm.get('gp')?.value }}</span>
                }
                @if (addProjectForm.get('yearOfCreation')?.value) {
                  <span class="ap-chip ap-chip--amber"><i class="fa-solid fa-calendar-days"></i>{{ addProjectForm.get('yearOfCreation')?.value }}</span>
                }
              </div>
            </div>
          </div>
          <button class="ap-close" (click)="closeAddProjectForm()" aria-label="Close modal">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- ── Scrollable Body ── -->
        <div class="ap-body">
          <form id="ap-create-form" [formGroup]="addProjectForm" (ngSubmit)="submitAddProject()" novalidate>

            <!-- ── Section 1: Project Details ── -->
            <div class="ap-section">
              <div class="ap-section-hdr">
                <i class="fa-solid fa-folder-open"></i>
                <span>Project Details</span>
              </div>
              <div class="ap-grid">

                <!-- Project Name (full width) -->
                <div class="ap-field ap-field--full">
                  <label>{{ drawerScheme!.roadLength !== undefined ? 'Road Name' : 'Project Name' }} <span class="ap-req">*</span></label>
                  <input type="text" formControlName="roadName"
                         [placeholder]="drawerScheme!.roadLength !== undefined ? 'Enter road name…' : 'Enter project name…'"
                         [class.ap-input-err]="addProjectForm.get('roadName')?.invalid && addProjectForm.get('roadName')?.touched" />
                  @if (addProjectForm.get('roadName')?.invalid && addProjectForm.get('roadName')?.touched) {
                    <span class="ap-err-msg">Required (min 3 characters).</span>
                  }
                </div>

                <!-- Scheme (read-only) -->
                <div class="ap-field">
                  <label>Scheme</label>
                  <div class="ap-readonly-field">
                    <i class="fa-solid fa-diagram-project"></i>
                    <span>{{ drawerScheme.name }}</span>
                  </div>
                </div>

                <!-- Block / Division -->
                <div class="ap-field">
                  <label>Block <span class="ap-req">*</span></label>
                  <input type="text" formControlName="division" placeholder="e.g. Dhamnagar Block"
                         [class.ap-input-err]="addProjectForm.get('division')?.invalid && addProjectForm.get('division')?.touched" />
                  @if (addProjectForm.get('division')?.invalid && addProjectForm.get('division')?.touched) {
                    <span class="ap-err-msg">Required.</span>
                  }
                </div>

                <!-- Gram Panchayat -->
                <div class="ap-field">
                  <label>Gram Panchayat</label>
                  <input type="text" formControlName="gp" placeholder="e.g. Chandibaunsagada" />
                </div>

                <!-- Status -->
                <div class="ap-field">
                  <label>Status <span class="ap-req">*</span></label>
                  <select formControlName="status">
                    <option value="Planned">Planned</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Completed">Completed</option>
                    <option value="Stuck">Stuck</option>
                  </select>
                </div>

                <!-- Year of Creation -->
                <div class="ap-field">
                  <label>Year of Creation</label>
                  <select formControlName="yearOfCreation">
                    <option value="">Select year</option>
                    <option value="2020-21">2020-21</option>
                    <option value="2021-22">2021-22</option>
                    <option value="2022-23">2022-23</option>
                    <option value="2023-24">2023-24</option>
                    <option value="2024-25">2024-25</option>
                    <option value="2025-26">2025-26</option>
                  </select>
                </div>

                <!-- Total Cost -->
                <div class="ap-field">
                  <label>Total Cost (₹ Lakh) <span class="ap-req">*</span></label>
                  <input type="number" formControlName="costLakh" placeholder="0.00" min="0.01" step="0.01"
                         [class.ap-input-err]="addProjectForm.get('costLakh')?.invalid && addProjectForm.get('costLakh')?.touched" />
                  @if (addProjectForm.get('costLakh')?.invalid && addProjectForm.get('costLakh')?.touched) {
                    <span class="ap-err-msg">Required, must be > 0.</span>
                  }
                </div>

                <!-- Amount Spent -->
                <div class="ap-field">
                  <label>Amount Spent (₹ Lakh)</label>
                  <input type="number" formControlName="spentLakh" placeholder="0.00" min="0" step="0.01" />
                </div>

                <!-- Road Length (road schemes only) -->
                @if (drawerHasLength) {
                  <div class="ap-field">
                    <label>Road Length (km)</label>
                    <input type="number" formControlName="lengthKm" placeholder="e.g. 5.25" min="0" step="0.01" />
                  </div>
                }

                <!-- Executant Name -->
                <div class="ap-field">
                  <label>Executant / Contractor</label>
                  <input type="text" formControlName="executantName" placeholder="Contractor or agency name" />
                </div>

                <!-- Executant Contact -->
                <div class="ap-field">
                  <label>Executant Contact</label>
                  <input type="tel" formControlName="executantContact" placeholder="Mobile number" />
                </div>

              </div>
            </div>

            <!-- ── Section 2: Site Photos ── -->
            <div class="ap-section">
              <div class="ap-section-hdr">
                <i class="fa-solid fa-camera"></i>
                <span>Site Photos</span>
                <span class="ap-section-note">Optional · JPG/PNG · max 2 MB · up to 5 per category</span>
              </div>

              @if (formMode === 'edit' && editingProjectId) {
                <app-photo-upload
                  [photos]="editingProjectPhotos()"
                  [projectId]="editingProjectId"
                  [canEdit]="true"
                  (photosChange)="onDeptProjectPhotosChanged($event)" />
              } @else {
                <div class="ap-photo-sections">

                  <!-- Before Work -->
                  <div class="ap-photo-cat">
                    <div class="ap-photo-cat-label ap-photo-cat-label--before">
                      <i class="fa-solid fa-camera-retro"></i> Before Work
                    </div>
                    <div class="ap-photo-thumbs">
                      @for (e of stagedPhotosBefore(); track e.previewUrl; let i = $index) {
                        <div class="ap-thumb">
                          <img [src]="e.previewUrl" alt="Before" />
                          <button type="button" class="ap-thumb-del" (click)="removeStagedPhotoCategory('before', i)" aria-label="Remove">
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                      }
                      @if (stagedPhotosBefore().length < 5) {
                        <label class="ap-thumb-add" title="Add before photo">
                          <i class="fa-solid fa-plus"></i>
                          <input type="file" multiple accept="image/jpeg,image/png" style="display:none"
                                 (change)="onCreatePhotoCategorySelected('before', $event)" />
                        </label>
                      }
                    </div>
                  </div>

                  <!-- During Work -->
                  <div class="ap-photo-cat">
                    <div class="ap-photo-cat-label ap-photo-cat-label--during">
                      <i class="fa-solid fa-camera"></i> During Work
                    </div>
                    <div class="ap-photo-thumbs">
                      @for (e of stagedPhotosDuring(); track e.previewUrl; let i = $index) {
                        <div class="ap-thumb">
                          <img [src]="e.previewUrl" alt="During" />
                          <button type="button" class="ap-thumb-del" (click)="removeStagedPhotoCategory('during', i)" aria-label="Remove">
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                      }
                      @if (stagedPhotosDuring().length < 5) {
                        <label class="ap-thumb-add" title="Add during photo">
                          <i class="fa-solid fa-plus"></i>
                          <input type="file" multiple accept="image/jpeg,image/png" style="display:none"
                                 (change)="onCreatePhotoCategorySelected('during', $event)" />
                        </label>
                      }
                    </div>
                  </div>

                  <!-- After Work -->
                  <div class="ap-photo-cat">
                    <div class="ap-photo-cat-label ap-photo-cat-label--after">
                      <i class="fa-solid fa-flag-checkered"></i> After Work
                    </div>
                    <div class="ap-photo-thumbs">
                      @for (e of stagedPhotosAfter(); track e.previewUrl; let i = $index) {
                        <div class="ap-thumb">
                          <img [src]="e.previewUrl" alt="After" />
                          <button type="button" class="ap-thumb-del" (click)="removeStagedPhotoCategory('after', i)" aria-label="Remove">
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                      }
                      @if (stagedPhotosAfter().length < 5) {
                        <label class="ap-thumb-add" title="Add after photo">
                          <i class="fa-solid fa-plus"></i>
                          <input type="file" multiple accept="image/jpeg,image/png" style="display:none"
                                 (change)="onCreatePhotoCategorySelected('after', $event)" />
                        </label>
                      }
                    </div>
                  </div>

                </div>
              }
            </div>

            <!-- ── Section 3: OSD Special Flags ── -->
            <div class="ap-section ap-section--last">
              <div class="ap-section-hdr">
                <i class="fa-solid fa-flag"></i>
                <span>OSD Special Flags</span>
                <span class="ap-section-note">Project appears in respective monitoring dashboards when flagged</span>
              </div>
              <div class="ap-flags">

                <label class="ap-flag" [class.ap-flag--active-blue]="hmPriorityFlag">
                  <div class="ap-flag-icon ap-flag-icon--blue"><i class="fa-solid fa-crown"></i></div>
                  <div class="ap-flag-text">
                    <strong>HM Decision Dashboard</strong>
                    <small>Appears in Minister's HM Priority view</small>
                  </div>
                  <div class="ap-flag-switch">
                    <input type="checkbox" formControlName="hmPriority"
                           (change)="onHmPriorityChange($any($event.target).checked)" />
                    <span class="ap-switch-track"></span>
                  </div>
                </label>

                <label class="ap-flag" [class.ap-flag--active-orange]="recurringFlag">
                  <div class="ap-flag-icon ap-flag-icon--orange"><i class="fa-solid fa-rotate"></i></div>
                  <div class="ap-flag-text">
                    <strong>Recurring Intervention</strong>
                    <small>Appears in Recurring Intervention page</small>
                  </div>
                  <div class="ap-flag-switch">
                    <input type="checkbox" formControlName="recurringIntervention"
                           (change)="onRecurringChange($any($event.target).checked)" />
                    <span class="ap-switch-track"></span>
                  </div>
                </label>

                <label class="ap-flag" [class.ap-flag--active-red]="delayedFlag">
                  <div class="ap-flag-icon ap-flag-icon--red"><i class="fa-solid fa-clock"></i></div>
                  <div class="ap-flag-text">
                    <strong>Delayed Project</strong>
                    <small>Appears in Delayed Projects monitoring page</small>
                  </div>
                  <div class="ap-flag-switch">
                    <input type="checkbox" formControlName="isDelayed"
                           (change)="onDelayedChange($any($event.target).checked)" />
                    <span class="ap-switch-track"></span>
                  </div>
                </label>

              </div>
            </div>

          </form>
        </div><!-- /ap-body -->

        <!-- ── Footer ── -->
        <div class="ap-footer">
          <button type="button" class="ap-btn-cancel" (click)="closeAddProjectForm()" [disabled]="isSaving()">
            Cancel
          </button>
          <button type="submit" form="ap-create-form" class="ap-btn-save" [disabled]="isSaving()">
            @if (isSaving()) {
              <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
              {{ formMode === 'edit' ? 'Updating…' : 'Saving…' }}
            } @else {
              <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
              {{ formMode === 'edit' ? 'Update Project' : 'Save Project' }}
            }
          </button>
        </div>

      </div>
    </div>
  }

  <!-- Drawer body: project table -->
  @if (!showAddForm && !opFocusEditMode()) {
    <div class="drawer-body" *ngIf="drawerScheme!.projectList?.length; else noProjects">
      <div class="drawer-table-wrap">
        <table class="drawer-table" id="scheme-projects-table">
          <thead>
            <tr>
              <th class="col-check w-8 px-2">
                <input type="checkbox"
                       class="w-4 h-4 accent-red-600 cursor-pointer"
                       [checked]="isAllSelected()"
                       (change)="toggleSelectAll()"
                       aria-label="Select all projects" />
              </th>
              <th class="col-sl">Sl.</th>
              <th class="col-road">{{ drawerScheme!.roadLength !== undefined ? 'Name of the Road' : 'Project / Scheme Name' }}</th>
              <th class="col-dist">District</th>
              <th class="col-div">Division / Block</th>
              <th class="col-len" *ngIf="drawerScheme!.roadLength !== undefined">Length (km)</th>
              <th class="col-cost">Approx. Cost (₹ Lakh)</th>
              <th class="col-status">Status</th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let proj of drawerScheme!.projectList; let j = index"
                [class.row-alt]="j % 2 !== 0"
                [class.row-deleting]="deletingSlNo === proj.slNo"
                [class.row-selected]="selectedSlNos().has(proj.slNo)">
              <td class="col-check w-8 px-2 td-center">
                <input type="checkbox"
                       class="w-4 h-4 accent-red-600 cursor-pointer"
                       [checked]="selectedSlNos().has(proj.slNo)"
                       (change)="toggleSelectProject(proj.slNo)"
                       [attr.aria-label]="'Select ' + proj.roadName" />
              </td>
              <td class="col-sl td-center">{{ proj.slNo }}</td>
              <td class="col-road td-road">{{ proj.roadName }}</td>
              <td class="col-dist td-center">{{ proj.district }}</td>
              <td class="col-div td-center">{{ proj.division }}</td>
              <td class="col-len td-center td-bold" *ngIf="drawerScheme!.roadLength !== undefined">{{ proj.lengthKm?.toFixed(2) ?? '–' }}</td>
              <td class="col-cost td-center td-bold">{{ proj.costLakh.toFixed(2) }}</td>
              <td class="col-status td-center">
                <select class="inline-status-select" [class]="getStatusClass(proj.status)"
                        [value]="proj.status ?? 'Planned'"
                        (change)="changeProjectStatus(proj, $any($event.target).value)"
                        [attr.aria-label]="'Status for ' + proj.roadName">
                  <option value="Planned">Planned</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Stuck">Stuck</option>
                </select>
              </td>
              <td class="col-actions td-center">
                @if (deletingSlNo === proj.slNo) {
                  <div class="inline-confirm" role="group" [attr.aria-label]="'Confirm delete ' + proj.roadName">
                    <span class="inline-confirm-text">Delete?</span>
                    <button class="btn-confirm-yes" (click)="confirmDeleteProject(proj.slNo)" aria-label="Confirm delete">
                      <i class="fa-solid fa-check"></i>
                    </button>
                    <button class="btn-confirm-no" (click)="cancelDeleteProject()" aria-label="Cancel delete">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                } @else {
                  <button class="btn-row-edit" (click)="openEditProjectForm(proj)"
                          [attr.aria-label]="'Edit ' + proj.roadName" title="Edit project">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button class="btn-row-delete" (click)="promptDeleteProject(proj.slNo)"
                          [attr.aria-label]="'Delete ' + proj.roadName" title="Delete project">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                }
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-total-row">
              <td [attr.colspan]="drawerScheme!.roadLength !== undefined ? 4 : 4" class="td-total-label">Total</td>
              <td class="td-center td-bold" *ngIf="drawerScheme!.roadLength !== undefined">{{ drawerTotalLength.toFixed(2) }} km</td>
              <td class="td-center td-bold">₹{{ drawerTotalCostLakh.toFixed(2) }} L</td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <ng-template #noProjects>
      <div class="drawer-empty">
        <i class="fa-solid fa-folder-open"></i>
        <p>No project data available yet for this scheme.</p>
        <span>Click <strong>Add Project</strong> above to get started.</span>
      </div>
    </ng-template>
  }
</div>

<!-- ================================================================
     SCHEME ADD / EDIT MODAL
     ================================================================ -->
@if (showSchemeForm()) {
<div class="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4"
     role="dialog" aria-modal="true"
     [attr.aria-labelledby]="schemeFormMode() === 'add' ? 'scheme-add-title' : 'scheme-edit-title'">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">

    <!-- Modal header -->
    <div class="flex items-center justify-between px-5 py-4 bg-indigo-50 border-b border-indigo-100">
      <h3 [id]="schemeFormMode() === 'add' ? 'scheme-add-title' : 'scheme-edit-title'"
          class="flex items-center gap-2 text-sm font-bold text-indigo-800">
        <i [class]="schemeFormMode() === 'add' ? 'fa-solid fa-plus-circle text-indigo-500' : 'fa-solid fa-pen-to-square text-indigo-500'"></i>
        {{ schemeFormMode() === 'add' ? 'Add New Scheme' : 'Edit Scheme' }}
      </h3>
      <button (click)="closeSchemeModal()" aria-label="Close"
              class="w-7 h-7 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-600 hover:bg-white transition">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Modal body -->
    <form [formGroup]="schemeForm" (ngSubmit)="submitSchemeForm()" novalidate class="p-5 space-y-4">

      <!-- Scheme Name -->
      <div>
        <label class="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1" for="sf-name">
          Scheme Name <span class="text-red-500">*</span>
        </label>
        <input id="sf-name" type="text" formControlName="name"
               placeholder="e.g. Gopabandhu Jana Arogya Yojana"
               class="w-full px-3 py-2.5 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
               [class.border-red-400]="schemeForm.get('name')?.invalid && schemeForm.get('name')?.touched"
               [class.border-slate-300]="!(schemeForm.get('name')?.invalid && schemeForm.get('name')?.touched)" />
        @if (schemeForm.get('name')?.invalid && schemeForm.get('name')?.touched) {
          <p class="text-xs text-red-500 mt-1">Scheme name is required (min 3 characters).</p>
        }
      </div>

      <!-- Budget + Spent -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1" for="sf-cost">
            Total Budget (₹ Lakh)
          </label>
          <input id="sf-cost" type="number" formControlName="totalCost" min="0" step="0.01"
                 placeholder="e.g. 1250.00"
                 class="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400" />
        </div>
        <div>
          <label class="block text-xs font-semibold text-slate-600 uppercase tracking-wide mb-1" for="sf-spent">
            Amount Spent (₹ Lakh)
          </label>
          <input id="sf-spent" type="number" formControlName="spent" min="0" step="0.01"
                 placeholder="e.g. 420.00"
                 class="w-full px-3 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400" />
        </div>
      </div>

      <!-- Department (informational) -->
      @if (selectedDept) {
        <div class="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-50 border border-slate-200">
          <i [class]="selectedDept.icon + ' text-slate-500 text-sm'"></i>
          <span class="text-xs text-slate-600 font-medium">Department: <strong>{{ selectedDept.name }}</strong></span>
        </div>
      }

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 pt-2 border-t border-slate-200">
        <button type="button" (click)="closeSchemeModal()"
                class="px-4 py-2 text-sm font-medium rounded-lg border border-slate-300 bg-white text-slate-600 hover:bg-slate-100 transition">
          Cancel
        </button>
        <button type="submit"
                class="px-4 py-2 text-sm font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition flex items-center gap-1.5">
          <i class="fa-solid fa-floppy-disk"></i>
          {{ schemeFormMode() === 'add' ? 'Create Scheme' : 'Save Changes' }}
        </button>
      </div>
    </form>
  </div>
</div>
}

<!-- ================================================================
     SCHEME DELETE CONFIRMATION MODAL
     ================================================================ -->
@if (showDeleteSchemeConfirm()) {
<div class="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4"
     role="alertdialog" aria-modal="true" aria-labelledby="del-scheme-title">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-xs p-6 text-center">
    <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-3">
      <i class="fa-solid fa-trash-can text-red-600 text-lg"></i>
    </div>
    <h3 id="del-scheme-title" class="text-base font-bold text-slate-900 mb-1">Delete Scheme?</h3>
    <p class="text-sm text-slate-500 mb-5">
      "<strong>{{ selectedDept?.schemes?.[deletingSchemeIndex()]?.name }}</strong>" and all its project data will be removed. This cannot be undone.
    </p>
    <div class="flex gap-3">
      <button type="button" (click)="cancelDeleteScheme()"
              class="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition">Cancel</button>
      <button type="button" (click)="confirmDeleteScheme()"
              class="flex-1 px-3 py-2 bg-red-600 text-white rounded-lg text-sm font-semibold hover:bg-red-700 transition">
        <i class="fa-solid fa-trash-can mr-1"></i> Delete
      </button>
    </div>
  </div>
</div>
}

<!-- ============================================================
     PROJECT DETAIL / EDIT MODAL — opened from the project-name
     link in the department table. Minister sees it read-only;
     OSD sees an Edit button and can save changes back to Firestore.
     ============================================================ -->
@if (deptProjectDetail(); as proj) {
  <div class="dpm-overlay" (click)="closeDeptProjectModal()">
    <div class="dpm-card" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">

      <!-- Sticky header -->
      <div class="dpm-header">
        <div class="dpm-title-wrap">
          <div class="dpm-icon" [ngClass]="getDeptBg(selectedDept?.color || '')">
            <i class="fa-solid fa-diagram-project"></i>
          </div>
          <div>
            <h3 class="dpm-title">{{ proj.roadName }}</h3>
            <p class="dpm-subtitle">
              {{ proj.schemeShort || proj.schemeName }} ·
              {{ proj.district || '—' }} ·
              {{ proj.division || '—' }}
            </p>
          </div>
        </div>
        <button class="dpm-close" (click)="closeDeptProjectModal()" aria-label="Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <!-- Scrollable body -->
      <div class="dpm-body">
        @if (!isDeptProjectEditing()) {
          <!-- ───── View mode ───── -->
          <div class="dpm-view-grid">
            <div class="dpm-field"><span class="dpm-lbl">Road / Project Name</span><span class="dpm-val">{{ proj.roadName || '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Scheme</span><span class="dpm-val">{{ proj.schemeName || '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">District</span><span class="dpm-val">{{ proj.district || '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Division / Block</span><span class="dpm-val">{{ proj.division || '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Constituency</span><span class="dpm-val">{{ proj.constituency || '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Status</span><span class="dpm-val"><span [class]="opStatusClass(proj.status)">{{ proj.status || 'Planned' }}</span></span></div>
            <div class="dpm-field"><span class="dpm-lbl">Length (km)</span><span class="dpm-val">{{ proj.lengthKm != null ? (proj.lengthKm | number:'1.1-2') : '—' }}</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Approx Cost</span><span class="dpm-val">₹{{ proj.costLakh | number:'1.0-2' }} L</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Amount Spent</span><span class="dpm-val">₹{{ (proj.spentLakh ?? 0) | number:'1.0-2' }} L</span></div>
            <div class="dpm-field"><span class="dpm-lbl">Progress</span><span class="dpm-val">{{ opProgressOf(proj) }}%</span></div>
            <div class="dpm-field"><span class="dpm-lbl">HM Priority</span>
              <span class="dpm-val">
                @if ($any(proj).hmPriority) {
                  <span class="dpm-chip dpm-chip-on"><i class="fa-solid fa-crown"></i> Yes</span>
                } @else { <span class="dpm-chip dpm-chip-off">No</span> }
              </span>
            </div>
            <div class="dpm-field"><span class="dpm-lbl">Recurring Intervention</span>
              <span class="dpm-val">
                @if ($any(proj).recurringIntervention) {
                  <span class="dpm-chip dpm-chip-on dpm-chip-rec"><i class="fa-solid fa-rotate"></i> Yes</span>
                } @else { <span class="dpm-chip dpm-chip-off">No</span> }
              </span>
            </div>
          </div>
        } @else {
          <!-- ───── Edit mode (OSD only) ───── -->
          <form [formGroup]="deptProjectForm" class="dpm-edit-grid">
            <div class="dpm-fg dpm-fg-wide">
              <label>Road / Project Name <span class="dpm-req">*</span></label>
              <input type="text" formControlName="roadName" placeholder="Enter project name" />
              @if (deptProjectForm.get('roadName')?.touched && deptProjectForm.get('roadName')?.invalid) {
                <small class="dpm-error">A descriptive project name is required (min 3 chars).</small>
              }
            </div>

            <div class="dpm-fg">
              <label>District <span class="dpm-req">*</span></label>
              <input type="text" formControlName="district" />
            </div>
            <div class="dpm-fg">
              <label>Division / Block <span class="dpm-req">*</span></label>
              <input type="text" formControlName="division" />
            </div>

            <div class="dpm-fg">
              <label>Constituency <span class="dpm-req">*</span></label>
              <input type="text" formControlName="constituency" />
            </div>
            <div class="dpm-fg">
              <label>Status <span class="dpm-req">*</span></label>
              <select formControlName="status">
                <option value="Planned">Planned</option>
                <option value="In Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Stuck">Stuck</option>
              </select>
            </div>

            <div class="dpm-fg">
              <label>Length (km)</label>
              <input type="number" step="0.01" formControlName="lengthKm" placeholder="0.00" />
            </div>
            <div class="dpm-fg">
              <label>Approx Cost (₹L) <span class="dpm-req">*</span></label>
              <input type="number" step="0.01" formControlName="costLakh" placeholder="0.00" />
            </div>
            <div class="dpm-fg">
              <label>Amount Spent (₹L)</label>
              <input type="number" step="0.01" formControlName="spentLakh" placeholder="0.00" />
            </div>

            <div class="dpm-fg dpm-fg-wide">
              <div class="dpm-flags">
                <label class="dpm-flag">
                  <input type="checkbox"
                         [checked]="!!deptProjectForm.get('hmPriority')?.value"
                         (change)="onModalHmPriorityChange($any($event.target).checked)" />
                  <span><i class="fa-solid fa-crown text-amber-500"></i> HM Priority</span>
                </label>
                <label class="dpm-flag">
                  <input type="checkbox"
                         [checked]="!!deptProjectForm.get('recurringIntervention')?.value"
                         (change)="onModalRecurringChange($any($event.target).checked)" />
                  <span><i class="fa-solid fa-rotate text-blue-500"></i> Recurring Intervention</span>
                </label>
                <small class="dpm-flag-hint">A project can be either HM Priority or Recurring — not both.</small>
              </div>
            </div>
          </form>
        }
      </div>

      <!-- Sticky footer -->
      <div class="dpm-footer">
        @if (deptProjectSaveError()) {
          <div class="dpm-save-error">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>{{ deptProjectSaveError() }}</span>
          </div>
        }

        <div class="dpm-footer-actions">
          @if (!isDeptProjectEditing()) {
            <button type="button" class="dpm-btn dpm-btn-secondary" (click)="closeDeptProjectModal()">
              Close
            </button>
            @if (isOsd()) {
              <button type="button" class="dpm-btn dpm-btn-primary" (click)="enterDeptProjectEditMode()">
                <i class="fa-solid fa-pen-to-square"></i> Edit Project
              </button>
            }
          } @else {
            <button type="button" class="dpm-btn dpm-btn-secondary"
                    (click)="cancelDeptProjectEdit()"
                    [disabled]="isSavingDeptProject()">
              Cancel
            </button>
            <button type="button" class="dpm-btn dpm-btn-primary"
                    (click)="saveDeptProjectChanges()"
                    [disabled]="isSavingDeptProject()">
              @if (isSavingDeptProject()) {
                <i class="fa-solid fa-spinner fa-spin"></i> Saving…
              } @else {
                <i class="fa-solid fa-floppy-disk"></i> Update Project
              }
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
